import { useContext } from "react";
import { useSelector } from "react-redux";
import { Comment, Id, Identifiable, Project } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  logs: Identifiable<Comment>[];
  retrieveProjectLogs(
    projectId: Boundaries["retrieveProjectLogs"]["request"],
  ): void;
}

function useRetrieveProjectLogs(projectId: Id): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isProjectLogsRetrievalRequestPending(projectId),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isProjectLogsRetrievalRequestSuccess(projectId),
    ),
    isRequestFailure: useSelector(() =>
      selector.isProjectLogsRetrievalRequestFailure(projectId),
    ),
    logs: useSelector(() => selector.getProjectLogs(projectId)),
    retrieveProjectLogs: core.retrieveProjectLogs,
  };
}

export { useRetrieveProjectLogs };
